<div class="body">
<p>
  Client Set Success !
</p>
</div>
<app-rback [rurl]="'/main'"></app-rback>